module.exports = __webpack_public_path__ + "static/media/nr.d78a0bcc.webp";